import { Formik, Form } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { shallowEqual } from 'recompose';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import { includeStamp } from 'src/utils/StampUtils';
import { cloneDeep } from 'lodash-es';
import { caseUpsertAction } from '../actions/CaseActions';
import {
    VehicleQuotationDefaultProps,
    VehicleQuotationDefaultSchema,
} from '../CasePropTypes';
import VehicleInsuranceQuotationComponent from './VehicleInsuranceQuotationComponent';
import { STAGE_TYPES } from '../CaseConstants';
import VehicleInsuranceQuotationList from './VehicleInsuranceQuotationList';

let setSubmitting = () => {};

function VehicleInsuranceQuotationForm() {
    const dispatch = useDispatch();
    const { currentRecord, populatedCurrentRecord, upsertReqStatus } = useSelector((state) => state.CaseReducer, shallowEqual);

    // if current record changed or request status changed the enable submit
    usePrevious(
        {
            currentRecord,
            upsertReqStatus,
        },
        (prev) => {
            if (
                prev.currentRecord !== currentRecord
        || (upsertReqStatus
          && prev.upsertReqStatus !== upsertReqStatus
          && upsertReqStatus !== REQUEST_STATUS.PENDING)
            ) {
                setSubmitting(false);
            }
        },
    );

    const onSubmit = (values, formikUtils) => {
        ({ setSubmitting } = formikUtils);
        const newRecord = cloneDeep(currentRecord);

        includeStamp(newRecord);
        includeStamp(values);

        if (!newRecord.quotations) {
            newRecord.quotations = [];
        }
        newRecord.quotations.push(values);

        dispatch(caseUpsertAction(newRecord));
    };

    const onApproveClick = (record) => {
        const newRecord = { ...currentRecord };
        newRecord.quotations.forEach((quotation) => {
            if (quotation._id === record._id) {
                // eslint-disable-next-line no-param-reassign
                quotation.isApproved = true;
                includeStamp(quotation);
            }
            else {
                // eslint-disable-next-line no-param-reassign
                quotation.isApproved = false;
            }
        });

        includeStamp(newRecord);
        dispatch(caseUpsertAction(newRecord));
    };

    return (
        <div>
            <Formik
                onSubmit={onSubmit}
                initialValues={{ ...VehicleQuotationDefaultProps }}
                validationSchema={VehicleQuotationDefaultSchema}
            >
                {(formikProps) => (
                    <Form>
                        <VehicleInsuranceQuotationComponent
                            caseType={populatedCurrentRecord.caseType}
                            vehicleInsuranceInterestRate={populatedCurrentRecord?.catalogueId?.meta?.vehicleInsuranceInterestRate}
                            thirdPartyValue={populatedCurrentRecord?.catalogueId?.meta?.thirdPartyValue}
                            ownerValue={populatedCurrentRecord?.catalogueId?.meta?.ownerValue}
                            paidDriverValue={populatedCurrentRecord?.catalogueId?.meta?.paidDriverValue}
                            passengerValue={populatedCurrentRecord?.catalogueId?.meta?.passengerValue}
                            cngThirdPartyValue={populatedCurrentRecord?.catalogueId?.meta?.cngThirdPartyValue}
                            disableSubmit={currentRecord.stage !== STAGE_TYPES.QUOTATION}
                            disableSubmitMessage={'Case state must be "Quotation" for adding a quotation'}
                            submitButtonText="Add Quotation"
                            permissionScope="flow.case_manager.vehicle_insurance_quotations.submit"
                            {...formikProps}
                        />
                    </Form>
                )}
            </Formik>
            <VehicleInsuranceQuotationList
                canApprove={currentRecord.stage !== STAGE_TYPES.QUOTATION}
                quotations={currentRecord.quotations}
                onApproveClick={onApproveClick}
            />
        </div>
    );
}

export default VehicleInsuranceQuotationForm;
